export default "__VITE_ASSET__587f2a82__"